<template>
  <div class="container last-page visitor">
    <div class="content">
      <div class="header">
        <p>Stap 3 / 3</p>
        <h1>
          <strong>Bedankt voor uw deelname!</strong><br/>
          We laten je binnenkort weten of je gewonnen hebt!
        </h1>
      </div>
      <div class="group">
        <span class="emoji">🤞</span>
        <p>Uw deelname werd goed geregistereerd. Indien u heeft gewonnen ontvangt u van ons een bericht via e-mail na afloop van deze beurs.</p>
        <ck-progressbar class="small" :max="maxSeconds" :value="secondsLeft" />
      </div>
      <div class="group">
        <p>Het Quality Guard Team</p>
        <img class="img-logo" alt="Logo Quality Guard" src="~@/assets/images/logo-white.png">
      </div>
    </div>
  </div>
</template>

<script>
import timerPage from "@/mixins/timer_page";

export default {
    mixins: [timerPage]
};
</script>
